const PHASES: Array<{ code: string; name: string; desc: string }> = [
  { code: "S1", name: "Source", desc: "The intent statement the team can repeat without notes." },
  { code: "S2", name: "Success", desc: "What \"working\" means. Numbers, thresholds, definitions of done." },
  { code: "S3", name: "Safety", desc: "Safeguards, human-in-loop checkpoints, the rollback path." },
  { code: "S4", name: "Steering", desc: "Decision rights, escalation paths, who can pause the system." },
  { code: "S5", name: "Switch", desc: "Kill criteria. The off-ramps. The thresholds that trigger them." },
  { code: "S6", name: "Sharpen", desc: "Maintenance practice — retraining cadence, drift checks." },
];

const CHECKPOINTS: Array<{ code: string; name: string; desc: string }> = [
  {
    code: "DR",
    name: "Deployment Readiness",
    desc: "Five checks against your deployment criteria before the system goes live or scales.",
  },
  {
    code: "CC",
    name: "Cross-Layer Consistency",
    desc: "Nine automated checks find contradictions across the six layers — gaps flag in real time.",
  },
];

export function Shape() {
  return (
    <section className="lp-shape" aria-labelledby="shape-heading">
      <h2 className="lp-shape__heading" id="shape-heading">
        The 6 layers of the Canvas
      </h2>
      <p className="lp-shape__lede">
        Six layers of coaching feed two automated checkpoints, which produce three signed documents.
      </p>

      <div className="lp-shape__row lp-shape__row--phases" aria-label="Six coaching layers">
        {PHASES.map((p) => (
          <article key={p.code} className="lp-shape__card lp-shape__card--phase">
            <div className="lp-shape__code">{p.code}</div>
            <h3 className="lp-shape__name">{p.name}</h3>
            <p className="lp-shape__desc">{p.desc}</p>
          </article>
        ))}
      </div>

      <div className="lp-shape__arrow" aria-hidden="true">↓ feeds into ↓</div>

      <div className="lp-shape__row lp-shape__row--checks" aria-label="Two automated checkpoints">
        {CHECKPOINTS.map((c) => (
          <article key={c.code} className="lp-shape__card lp-shape__card--check">
            <div className="lp-shape__code">{c.code}</div>
            <h3 className="lp-shape__name">{c.name}</h3>
            <p className="lp-shape__desc">{c.desc}</p>
          </article>
        ))}
      </div>

      {/* The "Signed governance documents" produces-block was removed (Pascal
          review #4) — it duplicated the Artifacts section that follows. */}
    </section>
  );
}
